<template>
    <v-dialog class="dialog-cities" maxWidth='600' v-if="dialogCity" v-model="dialogCity" hide-overlay transition="dialog-bottom-transition">

        <v-card maxWidth='600'>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{$t('areas_dashboard.cities_covered')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('closeDialog')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-list dense>
                <v-list-item-group color="primary">
                    <v-list-item v-for="(item, i) in cities" :key="i">
                        <v-list-item-content>
                            <v-list-item-title :class="`city-${item.name}`" v-text="item.name"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
            </v-list>

        </v-card>
    </v-dialog>
</template>

<script>
export default {

    name: 'DialogCities',

    props: ['dialogCity', 'cities']

}
</script>

<style>

</style>